/**
 * Dependencies.
 */
import AddressCoordinatesModel from '@/api/address/coordinates.model';
import applicationConstant from '@/modules/main/constants/application.constant';
import { BaseService } from '@/modules/main/services/base.service';

/**
 * Service.
 */
class AddressCoordinatesService extends BaseService<AddressCoordinatesModel> {
  /**
   * Constructor.
   */
  constructor() {
    super(
      AddressCoordinatesModel,
      AddressCoordinatesModel.name,
      applicationConstant.apiCustomerPublicUrl
    );
  }
}

/**
 * Export `addressCoordinatesService`.
 */
export const addressCoordinatesService = new AddressCoordinatesService();
